import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';
import { isPlatformBrowser } from '@angular/common';
import { environmentIa } from 'src/environments/environment.ia';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // private apiUrlIa = environmentIa.production ? `${environmentIa.apiUrlProd}/login` : `${environmentIa.apiUrl}/login`;
  // private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  private tokenKey = 't';

  constructor(private http: HttpClient,
    private router: Router, 
    private storageService: StorageService,
    @Inject(PLATFORM_ID) private platformId: Object) { }

  getToken(): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }
    return this.storageService.getItem(this.tokenKey);
  }
}
